// extracted by mini-css-extract-plugin
export default {"headerBlock":"creature-condition-menu_headerBlock__x4UPl","conditionsButton":"creature-condition-menu_conditionsButton__qhSfz"};